import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import SVG from 'react-inlinesvg';
import {
  Section,
  SectionHeader,
  Paragraph,
  FullwidthImage,
  Link,
} from 'components';
import chartTopTech from 'assets/images/digital-transformation/top-technologies-implemented.svg';
import chartTopTechInvestigated from 'assets/images/digital-transformation/technologies-investigated-by-companies.svg';
import './Technologies.scss';

const Technologies = () => (
  <StaticQuery
    query={graphql`
      query {
        teamImage: file(relativePath: { eq: "office/office-1.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <Section color={'mine-shaft'}>
          <SectionHeader
            size={'big'}
            color={'white'}
            lineColor={'red'}
            headingType={2}
          >
            Top technologies implemented
          </SectionHeader>
          <div
            className={
              'digital-transformation__chart digital-transformation__chart--full'
            }
          >
            <SVG src={chartTopTech} alt={'Top technologies implemeneted'} />
          </div>
          <Link
            to={
              'http://resources.idg.com/download/white-paper/2018-digital-business'
            }
          >
            <Paragraph
              color={'white'}
              size={'small'}
              additionalClass={
                'text--light digital-transformation__chart-source'
              }
            >
              Source: IDG
            </Paragraph>
          </Link>
        </Section>
        <div className={'digital-transformation__container'}>
          <FullwidthImage image={data.teamImage.childImageSharp.fluid} />
          <div className={'w-container--left'}>
            <div
              className={
                'digital-transformation__chart digital-transformation__chart--absolute'
              }
            >
              <SectionHeader
                size={'medium'}
                lineColor={'pigeon-post'}
                headingType={2}
              >
                Top technologies currently investigated by companies:
              </SectionHeader>
              <SVG
                src={chartTopTechInvestigated}
                alt={'Top technologies investigated by companies'}
              />
              <Link
                to={
                  'http://resources.idg.com/download/white-paper/2018-digital-business'
                }
              >
                <Paragraph
                  color={'black'}
                  size={'small'}
                  additionalClass={
                    'text--light digital-transformation__chart-source'
                  }
                >
                  Source: IDG
                </Paragraph>
              </Link>
            </div>
          </div>
        </div>
      </>
    )}
  />
);

export default Technologies;
